<template>
  <div class="modal fade" tabindex="-1" :id="id">
    <div class="modal-dialog modal-md">
      <form @submit.prevent="askBook" class="form mt-5" >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('events.participator.askBook') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click.prevent="closeModal" aria-label="Close">
              <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                  </svg>
              </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />
            <div class="flex-column current">
              <div class="table-responsive">
                <table class="table table-flush table-borderless table-head-custom table-vertical-center align-middle gy-7 gx-3">
                  <tbody>
                  <tr>
                    <th  class="fw-bolder required">
                      {{ $t('events.participator.participator') }}
                    </th>
                    <th style="width: 130px" class="fw-bolder required">{{ $t('events.participator.bookNumber') }}</th>
                    <th class="fw-bolder" style="text-align: end !important;"></th>
                  </tr>
                  <tr v-for="(itemData, key) in formData.participators" :key="key" class="border border-start-0 border-end-0 shadow-sm align-top">
                    <td>
                      <Select2
                        :parent-id="'#'+id"
                        containerClass="form-group mt-auto"
                        :name="'participator'+id+key"
                        :multiple="false"
                        labelClass="mb-3"
                        selectClass="form-select form-select-solid"
                        :isRequired="false"
                        :placeholderText="$t('events.participator.participator')"
                        v-model="itemData.id"
                        >
                          <option v-for="participator in participators" :key="participator?.id" :value="participator?.id">
                            {{ participator?.firstname }}{{ participator?.lastname }}
                          </option>
                      </Select2>
                    </td>
                    <td>
                      <Input
                          container-class="form-group mt-auto"
                          :name="`item-${key}-book_number`"
                          type="number"
                          labelClass="form-label fs-6 text-black"
                          :inputClass="'form-control form-control-lg form-control-solid'"
                          :isRequired="true"
                          size="lg"
                          :min="1"
                          v-model="itemData.book_number"
                      />
                    </td>
                    <th>
                      <a class="btn btn-sm btn-icon btn-danger p-5" @click.prevent="removeItemRow(index)">
                        <i class="bi bi-trash-fill fs-5"></i>
                      </a>
                    </th>
                  </tr>
                  <tr>
                    <td colspan="3" style="padding-right: 0px !important;">
                      <div class="justify-content-end align-items-end float-end mt-5">
                        <a class="btn btn-primary" @click="addItemRow">
                          {{ $t('events.participator.add') }}
                        </a>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <Button  btn-class="btn-sm me-2" type="cancel" btn-text="button.close" size="7px 30px" @click.prevent="closeModal"/>
            <Button  btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>

import {computed, defineProps, ref, watch, onMounted} from 'vue';
import { useStore } from "vuex";
import Button from "@/components/Button.vue"
import Input from "@/components/Input.vue";
import Select2 from "@/components/Select2.vue";
import {useLocales} from "@/composables/locales";
import RequiredText from "@/components/RequiredText.vue";


const { locale } = useLocales()
const store = useStore()

const emit = defineEmits(['created'])
const props = defineProps({
  data:{
    type:Object,
    default: () => ({
      participators: [{id: '', book_number: ''}],
    })
  },
  id:{type: String} ,
})

const formData = ref(props.data)
const isLoading = ref(false)

const participators = computed(() => store.getters['events/getEventValidatedParticipators'])



watch(() => props.data, (value) => {
  formData.value = props.data
}, { deep: true })


function addItemRow() {
  formData.value.participators.push({
    id: '',
    book_number: 1,
  })
}

function removeItemRow(index) {
  if (formData.value.participators.length > 1) {
    formData.value.participators.splice(index, 1)
  }
}

function closeModal(){
  $('#'+props.id).modal('toggle')
}
function askBook() {
  isLoading.value = true
  store.dispatch('events/askBookForParticipator', formData.value)
    .then(res => {
      window.toastr.success(i18n.global.t("notification.book_asked_successfully"))
      emit('created')
      formData.value= {
        participators: [{id: '', book_number: ''}]
      }
    
      isLoading.value = false
      $('#'+props.id).modal('toggle')
    })
    .finally(() => isLoading.value = false)
 
}

onMounted(() => {

})


</script>
